const loadInbox = async () => {
  const mod = await import("views/Admin/Inbox");
  const Inbox = mod.default;
  return { Component: Inbox };
};

const inboxRoutes = [
  {
    path: "inbox",
    lazy: loadInbox,
  },
  {
    path: "inbox/:id",
    lazy: loadInbox,
  },
];

export default inboxRoutes;
